import { line } from 'd3-shape';
import { Selection } from 'd3-selection';

export interface TrapezoidPath {
    key: string;
    points: [number, number][];
}

export function drawTrapezoids(
    svg: Selection<SVGSVGElement | null, unknown, null, undefined>,
    data: TrapezoidPath[]
) {
    const update = svg
        .selectAll<SVGPathElement, TrapezoidPath[]>('path')
        .data(data);

    formatPath(update.enter().append('path'));
    formatPath(update);
    update.exit().remove();
}

const toLine = line()
    .x((d) => d[0])
    .y((d) => d[1]);

function formatPath(
    path: Selection<
        SVGPathElement,
        TrapezoidPath,
        SVGSVGElement | null,
        unknown
    >
) {
    return path
        .attr('d', (d) => toLine(d.points) + 'Z')
        .attr('class', (d) => d.key);
}
